import React from 'react';
import SliderStyle from './styles';

const Slider = ({ children, ...rest }) => {
  return (
    <SliderStyle {...rest} >
      {children}
    </SliderStyle>
  );
};

export default Slider;
